import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import FieldTag from "../../Form/FieldTags/FieldTag";
import { useEntityContext } from "../../../context/EntityContext";

const EntityForm = ({ activitiesData }) => {
  const navigate = useNavigate();
  const { appId, orgId } = useParams();
  const { selectedEntitySm } = useEntityContext();

  const handleFormNavigate = () => {
    navigate(`/organization/${orgId}/app/${appId}/smform/${selectedEntitySm.stateid}/form/${activitiesData.id}`);
  };

  return (
    <div className="activity-main-screen">
      <div className="form_field_container form-preview">
        <div className="form_field_wrapper">
          <div className="form_field_outer">
            <div className="form_edit_del_buttons">
              <ButtonActionIcon type="edit" size="md" onClick={handleFormNavigate} />
            </div>
            <div className="overlay_cover"></div>
            <div className="form_add_section_inside">
              {activitiesData?.form?.settings?.isMultiple &&
                activitiesData?.form?.sections.map((section, index) => (
                  <div key={index} className={`section-button`}>
                    {section.name.charAt(0).toUpperCase() + section.name.slice(1)}
                  </div>
                ))}
            </div>
            {activitiesData?.form?.sections?.length > 0 && (
              <div className="entity_form_container">
                {activitiesData?.form?.sections[0]?.fields.map((field) => {
                  const { ...fieldWithoutKey } = field;
                  return <FieldTag key={field.id} element={fieldWithoutKey} />;
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntityForm;
